import { render } from "./ListeClientPage.vue?vue&type=template&id=2ca955e3&ts=true"
import script from "./ListeClientPage.vue?vue&type=script&lang=ts"
export * from "./ListeClientPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__